module.exports = __webpack_public_path__ + "media/notify-pop.b62f91c6.wav";